import InputFieldContainer, { InputFieldContainerProps } from './InputFieldContainer';
import { ReadOnlyInput } from '@athena/forge';
import { useMemo } from 'react';
import { useWidgetContext } from '../context/WidgetContext';
import { getLocalizedString } from '../../utils/i18n-utils';
import ImpersonatedUsernameField from './ImpersonatedUsernameField';

export default function UsernameField(props: Readonly<InputFieldContainerProps>) {
  const username = useMemo(() => {
    const usernameSelector = 'identifier';
    const usernameField = props.inputFieldContainer.find(`[name=${usernameSelector}]`);
    if (usernameField.length) {
      // When there is a live okta session, both prompt=login and loginhint are needed to start a fresh login.
      // 'ANETUSERNAME' is a placeholder which will be cleared in OHSW
      if (usernameField.val() === 'ANETUSERNAME') {
        usernameField.val('');
      }
      else {
        return usernameField.val()?.toString();
      }
    }
  }, [ props.inputFieldContainer ]);

  const { athenaOneWebSessionTimedOut, athenaOneWebSso } = useWidgetContext();
  const commonProps = {
    labelText: getLocalizedString('primaryauth.username.label'),
    id: 'athena-username',
  };
  if ((athenaOneWebSessionTimedOut && username) || athenaOneWebSso) {
    // For SSO logout, username will not be displayed
    if (username) {
      return (
        <>
          <ImpersonatedUsernameField />
          <InputFieldContainer
            {...props}
            {...commonProps}
            inputAs={ReadOnlyInput}
            labelAlwaysAbove
            text={username}
            className="fe_u_font-weight--semibold fe_u_margin--bottom-medium"
          />
        </>
      );
    }
    else {
      return <></>;
    }
  }
  else {
    return <InputFieldContainer {...props} {...commonProps} autoFocus />;
  }
}
